import { memo } from 'react';
import { WbGrid, WbGridCol, WbGridRow, WbText } from '@workbench/react';
import RDivider from '../../Common/RDivider/RDivider';
import EquipmentImageCard from './EquipmentImageCard';
import './EquipmentRenderList.scss';

const COL_SPAN = { 1: 12, 2: 6, 3: 4, 4: 3, 6: 2 };

function EquipmentCategoryList({ imageList, rowCount = 6 }) {
	if (!imageList?.some((category) => category.images?.length)) return null;
	const span = COL_SPAN[rowCount] || 2;

	return (
		<WbGrid fullWidth>
			{imageList.map((category) => (
				<div key={category.dividerName || category.name}>
					<div className="vimdt-equipment-divider">
						<WbText size="s" strong>
							{category.dividerName}
						</WbText>
						<RDivider />
					</div>
					<WbGridRow>
						{category.images.map((image, index) => (
							<WbGridCol key={`${image.title}-${index}`} mq1={12} mq3={6} mq5={span}>
								<EquipmentImageCard
									url={image.url}
									title={image.title}
									imageType={image.imageType}
								/>
							</WbGridCol>
						))}
					</WbGridRow>
				</div>
			))}
		</WbGrid>
	);
}

export default memo(EquipmentCategoryList);
